import { styled } from '@/styled-system/jsx';

export const AppTemplateContainer = styled('div', {
  base: {
    height: '100%',
    width: '100%',
    letterSpacing: 'sm',
    backgroundColor: 'hpxWhite',
  },
  variants: {
    active: {
      true: {
        maxWidth: '100%',
        maxHeight: '100%',
        overflow: 'hidden',
        position: 'absolute',
      },
    },
  },
  defaultVariants: {
    active: false,
  },
});

export const AppTemplateModalContent = styled('div', {
  base: {
    md: {
      width: '320px',
    },
  },
});
